import React from 'react';
import { ThemeProvider } from '@mui/material';
import theme from './theming/theme';
import Clipboard from './app/services/Clipboard';
import './App.css';

function App() {
  return (
    <ThemeProvider theme={theme}>
      <Clipboard/>
    </ThemeProvider>)
}

export default App;
